<template>
  <main>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab :title="$t('all')"></b-tab>
          <b-tab :title="$t('waiting')"></b-tab>
          <b-tab :title="$t('confirmed')"></b-tab>
          <b-tab :title="$t('canceled')"></b-tab>
          <b-tab :title="$t('invoiceExported')"></b-tab>
          <b-tab :title="$t('invoiceNotExported')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <client-select v-if="!client" :model="filterFormModel" attribute="client" @change="search" :isFilter="true"
                           :place-holder="$t('selectClient')" class="mr-1 mb-1"></client-select>
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="method" :options="methods"></form-select>
            <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="type" :options="[
                {value: '-1', text: this.$t('allType')},
                {value: null, text: this.$t('service')},
                {value: 'plan', text: this.$t('plan')},
                {value: 'ai', text: this.$t('ai')}
            ]"></form-select>

            <time-range-picker :model="filterFormModel" :label="$t('confirmTime')"
                               class="mr-1 mb-1"></time-range-picker>

            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-4">{{ $t('client') }}</div>
            <div class="col-lg-4">{{ $t('info') }}</div>
            <div class="col-lg-4">{{ $t('invoice') }}</div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-4">
              <div>
                <b>{{ $t('client') }}: </b>
                <span>{{ item.client.companyName }}</span>
              </div>

              <div>
                <b>{{ $t('domain') }}: </b>
                <span>{{ item.client.domain }}</span>
              </div>

              <div>
                <b>{{ $t('invoiceCustomerName') }}: </b>
                <span v-if="item.client && item.client.invoiceCustomerName">{{ item.client.invoiceCustomerName }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>

              <div>
                <b>{{ $t('invoiceEmail') }}: </b>
                <span v-if="item.client && item.client.invoiceEmail">{{
                    item.client.invoiceEmail.replace(/;/g, ', ')
                  }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>

              <div>
                <span v-if="item.client.manualInvoiceEnabled" class="badge badge-danger">{{
                    $t('manualInvoice')
                  }}</span>
                <span v-else-if="item.client.invoiceEnabled" class="badge badge-success">{{ $t('vat') }}</span>
                <span v-else class="badge badge-warning">{{ $t('customer') }}</span>
              </div>

              <p v-if="item.plan" class="mt-2">
                <b>{{ $t("planOrder") }}: </b>
                {{ $t(`${item.plan.type}PlanOrderType`) }}
                {{ item.plan.type === 'upgrade' ? $t('oldPlan').toLowerCase() : $t('planName').toLowerCase() }}
                <span v-if="item.plan.plan"> <b>{{ item.plan.plan.name }}</b></span>
                <span
                    v-if="item.plan.upgradedPlan"> {{ $t('upgradedPlan').toLowerCase() }}&nbsp;<b>{{ item.plan.upgradedPlan.name }}</b></span>
                -
                <label v-if="!item.plan.cancelTime && !item.plan.confirmTime" class="text-warning">{{
                    $t('waiting')
                  }}</label>
                <label v-if="item.plan.confirmTime" class="text-success">{{ $t('confirmed') }}</label>
                <label v-if="item.plan.cancelTime" class="text-dark">{{ $t('canceled') }}</label>
              </p>

              <div v-if="item.aiPackage" class="mt-2">
                <b>{{ $t(`${item.aiPackage.type}AIAgent`) }}:</b>
                {{ $t('monthCount').toLowerCase() }} {{ item.aiPackage.monthCount }},
                {{ $t('numberOfChatbot').toLowerCase() }} {{ item.aiPackage.limit }}
                -
                <label v-if="!item.aiPackage.cancelTime && !item.aiPackage.confirmTime"
                       class="text-warning">{{ $t('waiting') }}</label>
                <label v-if="item.aiPackage.confirmTime" class="text-success">{{ $t('confirmed') }}</label>
                <label v-if="item.aiPackage.cancelTime" class="text-dark">{{ $t('canceled') }}</label>
              </div>


            </div>
            <div class="col-lg-4">
              <p>
                <span :class="getClass(item)">{{ getStatus(item) }}</span>
              </p>
              <div>
                <b>{{ $t('amount') }}: </b>
                <span class="text-success">{{ item.amount | numFormat }} {{ item.client.country.currency }}</span>
              </div>
              <div>
                <b>{{ $t('content') }}: </b>
                <span>{{ item.content }}</span>
                <span v-if="!item.content" class="text-danger">{{ $t('na') }}</span>
              </div>
              <div>
                <b>{{ $t('method') }}: </b>
                <span class="text-primary">{{ $t(item.method) }}</span>
              </div>
              <div>
                <b>{{ $t('ref') }}: </b>
                <span>{{ item.ref }}</span>
                <span v-if="!item.ref" class="text-danger small">{{ $t('notUpdated') }}</span>
              </div>
              <div v-if="item.errorCode">
                <b>{{ $t('errorCode') }}: </b>
                <span>{{ item.errorCode }}</span>
              </div>
              <div v-if="item.errorMsg">
                <b>{{ $t('errorMsg') }}: </b>
                <span>{{ item.errorMsg }}</span>
              </div>

            </div>
            <div class="col-lg-4">
              <div>
                <b>{{ $t('createTime') }}: </b>
                <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </div>
              <div v-if="item.confirmTime">
                <b>{{ $t('confirmTime') }}: </b>
                <span>{{ item.confirmTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </div>
              <div v-if="item.confirmedBy">
                <b>{{ $t('confirmedBy') }}: </b>
                <span>{{ item.confirmedBy.name }}</span>
              </div>
              <div v-if="item.cancelTime">
                <b>{{ $t('cancelTime') }}: </b>
                <span>{{ item.cancelTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </div>
              <div><span class="badge badge-info" v-if="!item.client.manualInvoiceEnabled && item.manualInvoice">Xuất về cá nhân nếu là doanh nghiệp</span>
              </div>
              <div class="mb-2">
                <span class="badge badge-warning" v-if="!invoiceEnabled || item.client.manualInvoiceEnabled">Xuất hoá đơn thủ công</span>
                <span class="badge badge-success" v-else>Xuất hoá đơn tự động</span>

                <span v-if="item.type === 'plan'" class="badge badge-success ml-1">{{ $t('plan') }}</span>
                <span v-else-if="item.type === 'ai'" class="badge badge-primary ml-1">{{ $t('ai') }}</span>
                <span v-else class="badge badge-info ml-1">{{ $t('service') }}</span>
              </div>
              <template
                  v-if="!item.client.manualInvoiceEnabled && item.confirmTime && item.invoice && (!item.invoice.error && !item.invoice.no)">
                <div>
                  <span class="text-warning">Chờ xuất hoá đơn...</span>
                </div>
              </template>
              <template v-if="!item.client.manualInvoiceEnabled && item.confirmTime && item.invoice">
                <div v-if="item.invoice.no">
                  <b>Số hoá đơn: </b>
                  <span>{{ item.invoice.no }}</span>
                </div>
                <div v-if="item.invoice.date">
                  <b>Ngày xuất: </b>
                  <span>{{ item.invoice.date }}</span>
                </div>
                <div v-if="item.invoice.keySearch">
                  <b>Mã tra cứu: </b>
                  <span>{{ item.invoice.keySearch }}</span>
                </div>
                <div v-if="item.invoice.error || item.invoice.errorMsg">
                  <b>{{ item.invoice.error ? $t('errorMsg') : "Trạng thái" }}: </b>
                  <span :class="[item.invoice.error ? 'text-danger' : '']">{{ item.invoice.errorMsg }}</span>
                </div>
                <div v-if="item.invoice.keySearch">
                  <a :href="`${serviceUrl}/webhook/invoice/${item._id}`" target="_blank">Chi tiết hoá đơn</a>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>
<script>
import List from '@/mixins/List';
import ClientSelect from "@/components/ClientSelect";
import TimeRangePicker from "@/components/TimeRangePicker";
import _ from 'lodash';

export default {
  props: {
    client: null,
    tab: null
  },
  components: {
    TimeRangePicker,
    ClientSelect
  },
  mixins: [List],
  data: function () {
    return {
      serviceUrl: process.env.VUE_APP_SERVICE_URL,
      service: '/credit-deposit',
      defaultFormModel: {
        type: null,
        client: this.client ? this.client._id : null,
        method: 'bank',
        invoiceEnabled: true
      },
      defaultFilterFormModel: {
        type: "-1",
        status: 1,
        client: this.client ? this.client._id : null,
        method: null,
      },
      methods: [
        {value: null, text: this.$t('allMethods')},
        {value: 'bank', text: this.$t('bank')},
        {value: 'alepay', text: this.$t('alepay')},
        {value: 'momo', text: this.$t('momo')},
        {value: 'vnpay', text: this.$t('vnpay')},
      ],
      typeOptions: [
        {value: null, text: this.$t('service')},
        {value: 'plan', text: this.$t('plan')},
        {value: 'ai', text: this.$t('ai')},
      ],
      invoiceEnabled: false,
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    getStatus(item) {
      if (item.cancelTime) {
        return this.$t('canceled')
      } else if (item.confirmTime) {
        return this.$t('confirmed')
      } else if (item.method === 'bank') {
        return this.$t('waiting')
      } else if (!item.errorCode) {
        return this.$t('unfinished')
      } else if (item.errorCode === '150') {
        return this.$t('waiting')
      }
      return this.$t('undefined')
    },
    getClass(item) {
      if (item.cancelTime) return 'badge badge-dark'
      if (item.confirmTime) return 'badge badge-success'
      return 'badge badge-warning'
    },
  },
  watch: {
    tab: {
      immediate: true,
      handler(newVal) {
        this.filterFormModel.status = newVal;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        waiting: 'Waiting',
        waitConfirm: 'Waiting',
        confirmed: 'Confirmed',
        canceled: 'Canceled',
        info: 'Deposit info',
        amount: 'Amount',
        content: 'Content',
        method: 'Method',
        ref: 'Ref',
        na: 'Not available',
        notUpdated: 'Not updated',
        createTime: 'Create time',
        confirmTime: 'Confirm time',
        cancelTime: 'Cancel time',
        bank: 'Bank transfer',
        nganluong: 'Ngan Luong',
        momo: 'Momo',
        cancel: 'Cancel',
        confirm: 'Confirm',
        confirmDeposit: 'Are you sure to confirm this deposit?',
        confirmSuccess: 'Deposit confirmed!',
        cancelDeposit: 'Are you sure to cancel this deposit?',
        cancelSuccess: 'Deposit canceled!',
        error: 'Error!',
        save: 'Save',
        confirmNow: 'Confirm now',
        alepay: 'Alepay',
        unfinished: 'Unfinished',
        depositConfirmed: 'Deposit confirmed',
        errorGetingTransactionInfo: 'Error geting transaction info from Alepay',
        errorCode: 'Error code',
        errorMsg: 'Error message',
        updateStatus: 'Update status',
        allMethods: 'All methods',
        vnpay: "VnPay",
        confirmedBy: "Confirmed by",
        plan: "Plan order",
        service: "Service",
        allType: "Phân loại: Tất cả",
        newPlanOrderType: "Mới",
        "upgradePlanOrderType": "Nâng cấp gói dịch vụ",
        "extendPlanOrderType": "Gia hạn gói dịch vụ",
        "userPlanOrderType": "Mua thêm tài khoản",
        "unlimitedPlanOrderType": "Sử dụng gói \"Không giới hạn\"",
        "oldPlan": "Gói dịch vụ cũ",
        "upgradedPlan": "Gói dịch vụ mới",
        "planName": "Tên gói",
        "planOrder": "Gói dịch vụ",
        "invoice": "Hoá đơn",
        "exportInvoice": "Xuất hoá đơn",
        statusInvoice: "Đồng bộ hoá đơn",
        "aiPackage": "Nhân viên AI",
        "monthCount": "Số tháng",
        "numberOfChatbot": "Số nhân viên",
        ai: "Nhân viên AI - KCT",
        "newAIAgent": "Mua mới nhân viên AI",
        "extendAIAgent": "Gia hạn nhân viên AI",
        "userAIAgent": "Mua thêm nhân viên AI",
        invoiceExported: "Invoice exported",
        invoiceNotExported: "Invoice not exported",
        noteContent: "Note: Please provide detailed content",
        manualInvoice: "Manual Invoice",
        invoiceCustomerName: "Invoice Customer Name",
        vat: "VAT",
        customer: "Customer",
        invoiceEmail: "Invoice Email",
        invoiceInfoList: "Invoice Info List",
      },
      vi: {
        waiting: 'Đợi duyệt',
        waitConfirm: 'Đợi xác nhận',
        confirmed: 'Đã xác nhận',
        canceled: 'Đã huỷ',
        info: 'Thông tin lệnh chuyển tiền',
        amount: 'Số tiền',
        content: 'Nội dung',
        method: 'Phương thức',
        ref: 'Ref',
        na: 'Không có',
        notUpdated: 'Chưa cập nhật',
        createTime: 'Tạo lúc',
        confirmTime: 'Xác nhận lúc',
        cancelTime: 'Huỷ lúc',
        bank: 'Chuyển khoản',
        nganluong: 'Ngân lượng',
        momo: 'Momo',
        cancel: 'Hủy',
        confirm: 'Xác nhận',
        confirmDeposit: 'Bạn có chắc muốn xác nhận lệnh nạp tiền này?',
        confirmSuccess: 'Xác nhận lệnh nạp tiền thành công!',
        cancelDeposit: 'Bạn có chắc muốn hủy lệnh nạp tiền này?',
        cancelSuccess: 'Lệnh nạp tiền đã bị hủy!',
        error: 'Có lỗi xảy ra!',
        save: 'Lưu lại',
        confirmNow: 'Xác nhận ngay',
        alepay: 'Alepay',
        unfinished: 'Chưa hoàn thành',
        depositConfirmed: 'Lệch nạp tiền được xác nhận',
        errorGetingTransactionInfo: 'Có lỗi trong quá trình lấy thông tin từ Alepay',
        errorCode: 'Mã lỗi',
        errorMsg: 'Mô tả lỗi',
        updateStatus: 'Cập nhật trạng thái',
        allMethods: 'Tất cả các phương thức',
        vnpay: "VnPay",
        confirmedBy: "Xác nhận bởi",
        plan: "Mua gói - KCT",
        ai: "Nhân viên AI - KCT",
        service: "Dịch vụ - 10%",
        allType: "Phân loại: Tất cả",
        newPlanOrderType: "Mới",
        "upgradePlanOrderType": "Nâng cấp gói dịch vụ",
        "extendPlanOrderType": "Gia hạn gói dịch vụ",
        "userPlanOrderType": "Mua thêm tài khoản",
        "unlimitedPlanOrderType": "Sử dụng gói \"Không giới hạn\"",
        "oldPlan": "Gói dịch vụ cũ",
        "upgradedPlan": "Gói dịch vụ mới",
        "planName": "Tên gói",
        "planOrder": "Gói dịch vụ",
        "invoice": "Thông tin hoá đơn",
        "exportInvoice": "Xuất hoá đơn",
        statusInvoice: "Đồng bộ hoá đơn",
        "aiPackage": "Nhân viên AI",
        "monthCount": "Số tháng",
        "numberOfChatbot": "Số nhân viên",
        "newAIAgent": "Mua mới nhân viên AI",
        "extendAIAgent": "Gia hạn nhân viên AI",
        "userAIAgent": "Mua thêm nhân viên AI",
        invoiceExported: "Đã xuất hóa đơn",
        invoiceNotExported: "Chưa xuất hóa đơn",
        noteContent: "Ghi chú: Cần phải nhập cụ thể nội dung",
        manualInvoice: "Xuất hóa đơn thủ công",
        invoiceCustomerName: "Tên người mua hàng",
        invoiceEmail: "Email nhận hóa đơn",
        vat: "Xuất hóa đơn VAT",
        customer: "Khách lẻ",
        invoiceInfoList: "Danh sách xuất hóa đơn",
      }
    }
  }
}
</script>